import React from 'react'

import quickAdd_createEmbed from "../../../../../app/quick-add/sections/structure/embed/helpers/create-embed"
import {EmbedTypeConfigs} from "../../../../../core/gd/const/embed/embed-type-config"
import {NavigationMenuInlineAddParams} from "../../menu-add-with-popover/@types"
import NavigationMenuItemInputCommon from "./menu-item-add-common"
import {ProjectIconDictionary} from "../../../../../core/gd/const/project"

type Props = {
    level?          : number
    parentId?       : ID
    params          : NavigationMenuInlineAddParams

    onAdded         : {(isAdded:boolean):void}
}

// const debug = "NavigationMenuItemAddEmbed"
const debug = false

export default function NavigationMenuItemAddEmbed(props: Props) {

    const projectIcon = EmbedTypeConfigs[props.params.embedType!]?.projectIcon

    const onCommit = async (value?:string) => {
        // do nothing if no title
        if (!value) {
            props.onAdded(false)
            return
        }

        debug && console.log(debug, 'onChange', value)

        props.onAdded(true)

        const project = await quickAdd_createEmbed({
            parentProject   : props.parentId,
            name            : value,
            color           : gd.session.projects.get(props.parentId)?.color,
            projectIcon     : projectIcon,
            embedType       : props.params.embedType!
        })

        gd.goTo(project!.url)
    }

    return (
        <NavigationMenuItemInputCommon iconClass  = {ProjectIconDictionary[projectIcon as keyof {}]}
                                       level      = {props.level}
                                       parentId   = {props.parentId}
                                       onCommit   = {onCommit}/>
    )
}